<div class="u-padding-24" fxLayout="column">
  <div class="u-marginBottom-8">
    @if (
      hasUnmappedValues &&
      attributeSelection.translation &&
      !['group_fields', 'account_fields'].includes(attributeSelection.type)
    ) {
      <div
        class="u-borderRadius-card u-border-warning u-padding-16 u-marginBottom-16"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="16px"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="md-20 color-text-critical">error_outline</mat-icon>
          <p
            class="text-body-lg color-text-default u-marginLeft-16"
            i18n="@@attributeMappingDrawer.unmappedValuesWarning.text"
          >
            Add missing 10KC values to the Hub to map attributes
          </p>
        </div>
        <button
          (click)="addUnmappedValues()"
          color="primary"
          mat-stroked-button
          type="button"
          i18n="@@attributeMappingDrawer.unmappedValuesWarning.buttonText"
        >
          Add 10KC Values
        </button>
      </div>
    }
    <ol class="u-marginLeft-16">
      <li i18n="@@attributeMappingDrawer.descriptionList.one">
        Map your CSV field to a 10KC field, or create a new segment if it
        doesn't exist.
      </li>
      <li>
        <p
          class="u-marginBottom-16"
          i18n="@@attributeMappingDrawer.descriptionList.two"
        >
          Match each CSV value to a 10KC value; any blank mappings will not be
          imported.
        </p>
      </li>
    </ol>
    <div
      class="text-body-2"
      i18n="@@attributeMappingDrawer.descriptionList.helpCenterLink"
    >
      Visit
      <a
        appZendeskLink
        class="color-teal-700"
        href="https://support.tenthousandcoffees.com/hc/articles/19227001091092#01HACRGTFHQ43ESNF664PR6KEA"
        rel="noopener noreferrer"
        target="_blank"
        >our Help Center guide</a
      >
      for more details.
    </div>
  </div>
  @if (isAutomaticallyMappedField) {
    <div
      class="u-display-block u-padding-8 u-margin-0-16 u-margin-8-0 u-border-teal700 u-borderRadius--4px"
    >
      <div fxLayout="row" fxLayoutGap="16px">
        <div fxLayout="column" fxLayoutAlign="start start">
          <mat-icon
            class="material-symbols-outlined u-width-100 md-24 color-teal-700"
            >check_circle</mat-icon
          >
        </div>
        <div fxLayout="column">
          <b i18n="@@attributeMappingDrawer.alert.title"
            >Mapping will be completed by 10KC</b
          >
          <p i18n="@@attributeMappingDrawer.alert.description">
            Account fields such as first and last name, email, employee ID...
            will be mapped automatically by 10KC. No further actions required.
          </p>
        </div>
      </div>
    </div>
  }
  @if (hasUnmappedValues && attributeSelection.translation) {
    <div
      class="u-marginBottom-8"
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="8px"
    >
      <button
        [ngClass]="!hasMappedAllViableValues ? 'color-blue' : 'color-grey-300'"
        [nzTooltipTrigger]="hasMappedAllViableValues ? 'hover' : null"
        (click)="!hasMappedAllViableValues ? mapAllValues() : false"
        class="c-button"
        nz-tooltip
        nzTooltipPlacement="topRight"
        nzTooltipTitle="All values with matching words have been mapped."
        i18n="@@attributeMappingDrawer.nodeSelectionTable.mapAllValues.button"
        i18n-nzTooltipTitle="
          @@attributeMappingDrawer.nodeSelectionTable.mapAllValues.postTooltip"
      >
        Map values with matching words
      </button>
      <mat-icon
        [nzTooltipTrigger]="!hasMappedAllViableValues ? 'hover' : null"
        class="color-grey-300 md-16 u-cursor-pointer u-marginRight-16"
        nz-tooltip
        nzTooltipTitle="Automatically map CSV values to the 10KC values with the same words. You can change mappings afterwards"
        i18n-nzTooltipTitle="
          @@attributeMappingDrawer.nodeSelectionTable.mapAllValues.preTooltip"
      >
        info_outline
      </mat-icon>
    </div>
  }
  <nz-table
    [nzData]="[importedColumn]"
    [nzFrontPagination]="false"
    class="u-padding-0-16"
  >
    <thead>
      <tr>
        <th
          nzWidth="50%"
          i18n="@@attributeMappingDrawer.attributeTable.csvField"
        >
          CSV field
        </th>
        <th nzWidth="10%">
          <mat-icon class="md-16">arrow_forward</mat-icon>
        </th>
        <th
          nzWidth="40%"
          i18n="@@attributeMappingDrawer.attributeTable.10kcField"
        >
          10KC field
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td nzWidth="45%">
          {{ importedColumn.name }}
        </td>
        <td nzWidth="10%">
          <mat-icon class="md-16">arrow_forward</mat-icon>
        </td>
        <td nzWidth="45%">
          <nz-select
            [compareWith]="compareImportedColumn"
            [ngStyle]="{ width: '250px' }"
            [nzDropdownRender]="renderTemplate"
            [(ngModel)]="selected"
            (ngModelChange)="updateAttributeSelection($event)"
            nzAllowClear
            nzPlaceHolder="Choose 10KC field"
            nzShowSearch
            i18n-nzPlaceHolder="
              @@attributeMappingDrawer.attributeTable.placeHolder"
          >
            <nz-option-group [nzLabel]="dropDownLabels.group_fields">
              @for (item of groupOptions['group_fields']; track item) {
                <nz-option
                  [nzLabel]="item.label"
                  [nzValue]="{ selection: item, section: 'group_fields' }"
                >
                </nz-option>
              }
            </nz-option-group>
            <nz-option-group [nzLabel]="dropDownLabels.custom_segments">
              @for (item of groupOptions['custom_segments']; track item) {
                <nz-option
                  [nzLabel]="item.label"
                  [nzValue]="{ selection: item, section: 'custom_segments' }"
                >
                </nz-option>
              }</nz-option-group
            ><nz-option-group [nzLabel]="dropDownLabels.hidden_custom_segments">
              @for (
                item of groupOptions['hidden_custom_segments'];
                track item
              ) {
                <nz-option
                  [nzLabel]="item.label"
                  [nzValue]="{
                    selection: item,
                    section: 'hidden_custom_segments',
                  }"
                >
                </nz-option>
              }</nz-option-group
            ><nz-option-group [nzLabel]="dropDownLabels.account_fields">
              @for (item of groupOptions['account_fields']; track item) {
                <nz-option
                  [nzLabel]="item.label"
                  [nzValue]="{ selection: item, section: 'account_fields' }"
                >
                </nz-option>
              }
            </nz-option-group>
          </nz-select>
          <ng-template #renderTemplate
            ><div class="u-padding-8">
              <button
                (click)="openAddCustomSegmentDrawer(group, 'custom_segments')"
                class="c-button color-blue"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
              >
                <mat-icon class="md-12">add</mat-icon>
                <span
                  i18n="
                    @@attributeMappingDrawer.renderTemplate.newCustomSegmentButton"
                  >Add new segment</span
                >
              </button>
            </div>
            <div class="u-padding-8">
              <button
                (click)="
                  openAddCustomSegmentDrawer(group, 'hidden_custom_segments')
                "
                class="c-button color-blue"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
              >
                <mat-icon class="md-12">add</mat-icon>
                <span
                  i18n="
                    @@attributeMappingDrawer.renderTemplate.newHiddenCustomSegmentButton"
                  >Add new private segment</span
                >
              </button>
            </div>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </nz-table>
  @if (!isAutomaticallyMappedField) {
    <nz-table
      #nodeSelectionTable
      [nzData]="importedColumn.values"
      [nzFrontPagination]="true"
      [nzPageIndex]="pageIndex"
      [nzScroll]="{ x: '100%', y: '550px' }"
      (nzPageIndexChange)="pageIndex = $event"
      class="u-padding-0-16"
    >
      <thead>
        <tr>
          <th
            nzWidth="50%"
            i18n="@@attributeMappingDrawer.nodeSelectionTable.csvValue"
          >
            CSV value
          </th>
          <th nzWidth="10%">
            <mat-icon class="md-16">arrow_forward</mat-icon>
          </th>
          <th
            nzWidth="40%"
            i18n="@@attributeMappingDrawer.nodeSelectionTable.10kcValue"
          >
            10KC value
          </th>
        </tr>
      </thead>
      <tbody>
        @for (data of nodeSelectionTable.data; track $index) {
          <tr>
            <td nzWidth="45%">{{ data.name }}</td>
            <td nzWidth="10%">
              <mat-icon class="md-16">arrow_forward</mat-icon>
            </td>
            <td nzWidth="45%">
              <div fxLayout="row" fxLayoutAlign="start center">
                <nz-select
                  [compareWith]="compareSelectedValues"
                  [disabled]="hasTranslationBeenSelected()"
                  [ngStyle]="{ width: '250px' }"
                  [nzDropdownRender]="optionTemplate"
                  [(ngModel)]="valueSelections[pageIndex - 1][$index]"
                  (ngModelChange)="updateValueSelection(data.name, $event)"
                  nzAllowClear
                  nzPlaceHolder="Search 10KC value"
                  nzShowSearch
                  i18n-nzPlaceHolder="
                    @@attributeMappingDrawer.nodeSelectionTable.search10kcValue"
                >
                  @for (option of valueOptions; track option) {
                    <nz-option
                      [nzLabel]="option.label"
                      [nzValue]="option"
                    ></nz-option>
                  }
                </nz-select>
                @if (!valueSelections[pageIndex - 1][$index]) {
                  <mat-icon class="md-20 color-text-critical u-marginLeft-8"
                    >error_outline</mat-icon
                  >
                }
                <ng-template #optionTemplate>
                  @if (
                    'custom_segments' === attributeSelection.type ||
                    'hidden_custom_segments' === attributeSelection.type
                  ) {
                    <div class="u-padding-8">
                      <button
                        (click)="openAddSegmentOptionDrawer(data.name, $index)"
                        class="c-button color-blue"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="4px"
                      >
                        <mat-icon class="md-12">add</mat-icon>
                        <span
                          i18n="
                            @@attributeMappingDrawer.optionTemplate.newSegmentOptionButton"
                          >Add new option</span
                        >
                      </button>
                    </div>
                  }
                  @if ('group_fields' === attributeSelection.type) {
                    <div class="u-padding-8">
                      <button
                        (click)="openAddNewRoleDrawer(data.name, $index)"
                        class="c-button color-blue"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="4px"
                      >
                        <mat-icon class="md-12">add</mat-icon>
                        <span
                          i18n="
                            @@attributeMappingDrawer.optionTemplate.newRoleOptionButton"
                          >Add new role</span
                        >
                      </button>
                    </div>
                  }
                </ng-template>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  }
  <div
    class="u-borderTop-grey100 u-padding-0-24 u-paddingTop-16"
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button
      (click)="closeDrawer(group)"
      mat-raised-button
      i18n="@@global.cancel"
    >
      Cancel
    </button>
    <button
      [disabled]="hasTranslationBeenSelected()"
      (click)="submitAttributeMapping()"
      color="primary"
      mat-raised-button
      i18n="@@global.save"
    >
      Save
    </button>
  </div>
</div>
